export default "__VITE_ASSET__BMgOdUrr__"